function beat() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:autos:2019 :features&Specs"
    digitalData.pageInfo.languageSelected = "es";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "lat-am";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "beat";
    digitalData.vehicleInfo.bodyStyle = "beat ";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Form beat: features&Specs ";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function blazer() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:2020-blazer:especificaciones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "blazer";
    digitalData.vehicleInfo.bodyStyle = "blazer rs";
    digitalData.vehicleInfo.vehicleType = "crossover";
    digitalData.vehicleInfo.modelYear = "2020";
    digitalData.formInfo.formName = "Form blazer:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function captiva() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:captiva-camioneta:especificaciones-versiones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "captiva";
    digitalData.vehicleInfo.bodyStyle = "captiva ";
    digitalData.vehicleInfo.vehicleType = "suv";
    digitalData.vehicleInfo.modelYear = "2020";
    digitalData.formInfo.formName = "Form captiva: features&Specs ";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function cavalier() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:cars:2019-cavalier:especificaciones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "cavalier";
    digitalData.vehicleInfo.bodyStyle = "cavalier";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Form cavalier:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function equinox() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:2018-equinox:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "equinox";
    digitalData.vehicleInfo.bodyStyle = "equinox ";
    digitalData.vehicleInfo.vehicleType = "crossover";
    digitalData.vehicleInfo.modelYear = "2018";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function n300() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:van:2018:features&Specs"
    digitalData.pageInfo.languageSelected = "es";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "lat-am";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "n300";
    digitalData.vehicleInfo.bodyStyle = "n300";
    digitalData.vehicleInfo.vehicleType = "van";
    digitalData.vehicleInfo.modelYear = "2018";
    digitalData.formInfo.formName = "Form scross:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function onix() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageType = "tools";
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:cars:2021-onix-sedan:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "onix";
    digitalData.vehicleInfo.bodyStyle = "onix sedan";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2021";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function onixhb() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:truck:2019:features&specs"
    digitalData.pageInfo.languageSelected = "es";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "onix-hb";
    digitalData.vehicleInfo.bodyStyle = "onix-hb ";
    digitalData.vehicleInfo.vehicleType = "cars";
    digitalData.vehicleInfo.modelYear = "2021";
    digitalData.formInfo.formName = "Form onix-hb: features&Specs ";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function sail() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:cars:2019-sail:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "sail";
    digitalData.vehicleInfo.bodyStyle = "sail sedan";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function scross() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossover:2018:features&Specs"
    digitalData.pageInfo.languageSelected = "es";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "lat-am";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "scross";
    digitalData.vehicleInfo.bodyStyle = "scross";
    digitalData.vehicleInfo.vehicleType = "crossover";
    digitalData.vehicleInfo.modelYear = "2018";
    digitalData.formInfo.formName = "Form scross:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function sparkgtactiv() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:cars:spark-gt-activ:especificaciones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "spark";
    digitalData.vehicleInfo.bodyStyle = "spark gt activ";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Form spark gt activ:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function sparkgt() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageType = "tools";
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:cars:2019-spark-gt:especificaciones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "spark";
    digitalData.vehicleInfo.bodyStyle = "spark gt";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function tahoe() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:2019-tahoe:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";
    
    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "tahoe";
    digitalData.vehicleInfo.bodyStyle = "tahoe";
    digitalData.vehicleInfo.vehicleType = "suv";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Form scross:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function taxi() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:autos:2018:features&Specs"
    digitalData.pageInfo.languageSelected = "es";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "lat-am";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "taxi sail";
    digitalData.vehicleInfo.bodyStyle = "taxi sail";
    digitalData.vehicleInfo.vehicleType = "car";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Form sail:features&Specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function tracker() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:2018-tracker:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "tracker";
    digitalData.vehicleInfo.bodyStyle = "tracker";
    digitalData.vehicleInfo.vehicleType = "crossover";
    digitalData.vehicleInfo.modelYear = "2018";
    digitalData.formInfo.formName = "Form tracker: features&Specs ";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function trailblazer() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:crossovers-and-suvs:2018-trailblazer:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "trailblazer";
    digitalData.vehicleInfo.bodyStyle = "trailblazer";
    digitalData.vehicleInfo.vehicleType = "suv";
    digitalData.vehicleInfo.modelYear = "2018";
    digitalData.formInfo.formName = "form:trailblazer:feature-and-specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function dmax() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:pickups:2019-d-max:especificaciones";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "d max";
    digitalData.vehicleInfo.bodyStyle = "d-max-hp";
    digitalData.vehicleInfo.vehicleType = "truck";
    digitalData.vehicleInfo.modelYear = "2019";
    digitalData.formInfo.formName = "Formd-max-hp:features&specs";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

function dmaxpremier() {
    var digitalData = window.digitalData || {
        pageInfo: {},
        internalCampaignInfo: {},
        articleInfo: {},
        visitorProfile: {},
        vehicleInfo: {},
        toolsInfo: {},
        formInfo: {}
    };

    /* website indentification */
    digitalData.pageInfo.pageName = "ch:sa:ec:es:t1:pickups:2020-d-max-premier:features-and-specs";
    digitalData.pageInfo.languageSelected = "spanish";
    digitalData.pageInfo.country = "ecuador";
    digitalData.pageInfo.region = "south america west";
    digitalData.pageInfo.pageType = "tools";

    /* vehicle identification */
    digitalData.vehicleInfo.modelName = "d-max";
    digitalData.vehicleInfo.bodyStyle = "d-max-premier";
    digitalData.vehicleInfo.vehicleType = "truck";
    digitalData.vehicleInfo.modelYear = "2020";
    digitalData.formInfo.formName = "Form:dmax:feature-and-specs ";

    /* responsive design */
    var trackRenderedExperience = function () {
        if (window.innerWidth >= 1024) {
            digitalData.pageInfo.renderedExperience = 'large';
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            digitalData.pageInfo.renderedExperience = 'medium';
        } else if (window.innerWidth < 768) {
            digitalData.pageInfo.renderedExperience = 'small';
        }
    };

    var trackViewportSize = function () {
        digitalData.pageInfo.viewport = window.innerWidth + 'x' + window.innerHeight;
    };

    var trackOrientation = function () {
        if (window.innerWidth > window.innerHeight) {
            digitalData.pageInfo.orientation = 'landscape';
        } else {
            digitalData.pageInfo.orientation = 'portrait';
        }
    };

    trackRenderedExperience();
    trackViewportSize();
    trackOrientation();

    return digitalData;
}

export default {
    beat: beat(),
    blazer: blazer(),
    captiva: captiva(),
    cavalier: cavalier(),
    equinox: equinox(),
    n300: n300(),
    onix: onix(),
    onixhb: onixhb(),
    sail: sail(),
    scross: scross(),
    sparkgtactiv: sparkgtactiv(),
    sparkgt: sparkgt(),
    tahoe: tahoe(),
    taxi: taxi(),
    tracker: tracker(),
    trailblazer: trailblazer(),
    dmax: dmax(),
    dmaxpremier: dmaxpremier()
}